import * as React from "react";

import { IDayCell_Month } from "../../../classes/dayCell_Month";

import { MonthDayCellEvent } from "./MonthDayCellEvent";

import * as dates from "../../../reducers/changeTimePeriod";

export interface IMonthDayCellEvents {
    allDayText: string;
    dayCell: IDayCell_Month;
    eventText: string;
    monthStart: Date;
    userDateFormat: string;
    isLoading: boolean;
    portalId: number;
    portletInstanceId: number;
    pageId: number;
    objectId: number;
    onText: string;
    contextId: number;
    parentId: number;
    viewMode: string;
    selectedDate: Date;
    todaysDate: Date;
    toText: string;
    onSetEventId: (eventId: number) => any;
    onSetEventScreenMode: (eventScreenMode: string) => any;
    onSetiCalStartDate: (iCalStartDate: Date) => any;
    onSetDisplayedEventLocalStartDate: (localStartDate: Date) => any;
    onSetDisplayedEventLocalEndDate: (localEndDate: Date) => any;
    onStartAjaxCall: any;
}

function getEventsJSX(props: IMonthDayCellEvents) {
    const events: JSX.Element[] = [];

    const dayCell = props.dayCell;
    const monthStart = props.monthStart;
    const userDateFormat = props.userDateFormat;

    for (let e = 0; e < 3; e++) {

        if (dayCell.slots[e] === undefined) {
            // Event slot that's unused; needs a placeholder rendered.
            events.push(<li key={e} className="CAL-V-MV-multiPlaceholder" aria-hidden="true">{ /* EMPTY */}&nbsp;</li>);
        } else if (!dayCell.slots[e].isOccupiedAlready) {
            // Event slot with an event in it that needs to be rendered.
            events.push(
                <MonthDayCellEvent
                    key={e}
                    allDayText={props.allDayText}
                    contextId={props.contextId}
                    date={props.dayCell.date}
                    dayCellSlot={props.dayCell.slots[e]}
                    eventText={props.eventText}
                    monthStart={props.monthStart}
                    objectId={props.objectId}
                    onText={props.onText}
                    pageId={props.pageId}
                    parentId={props.parentId}
                    portalId={props.portalId}
                    portletInstanceId={props.portletInstanceId}
                    selectedDate={props.selectedDate}
                    todaysDate={props.todaysDate}
                    toText={props.toText}
                    userDateFormat={props.userDateFormat}
                    viewMode={props.viewMode}
                    onSetEventId={props.onSetEventId}
                    onSetEventScreenMode={props.onSetEventScreenMode}
                    onSetiCalStartDate={props.onSetiCalStartDate}
                    onSetDisplayedEventLocalStartDate={props.onSetDisplayedEventLocalStartDate}
                    onSetDisplayedEventLocalEndDate={props.onSetDisplayedEventLocalEndDate}
                    onStartAjaxCall={props.onStartAjaxCall}
                />);
        } else {
            // Event slot that's already occupied by a multi-day event; needs a placeholder rendered.
            events.push(<li key={e} className="CAL-V-MV-multiPlaceholder" aria-hidden="true">{ /* OCCUPIED */}&nbsp;</li>);
        }
    }

    return events;
}

export const MonthDayCellEvents = (props: IMonthDayCellEvents) => {

    if (!props.isLoading) {
        const events = getEventsJSX(props);

        return (
            <ul className="CAL-V-MV-row CAL-V-MV-events">
                {events}
            </ul>
        );
    } else {
        return null;
    }
};
